import moment from 'moment';
import { message } from 'antd';

import utilFetch from '@/utils/fetch';
import { getUrlParam } from '@/utils/url';

import { INVOICE_OPEN_STATUS, IS_EXPORT } from './constant';

const format = (v) => moment(v).format('YYYY-MM-DD HH:mm:ss');

const formatQueryParams = ({ queryParams, tab }) => {
  const {
    cur_page: page,
    per_page: pageSize,
    beginCreateTime_endCreateTime,
    beginFinishTime_endFinishTime,
    beginMealTime_endMealTime,
    invoiceOpenStatus,
    ...rest
  } = queryParams;

  const [beginCreateTime, endCreateTime] = (beginCreateTime_endCreateTime || []).map(format);
  const [beginFinishTime, endFinishTime] = (beginFinishTime_endFinishTime || []).map(format);
  const [beginMealTime, endMealTime] = (beginMealTime_endMealTime || []).map((v) =>
    moment(v).unix(),
  );

  return {
    page,
    pageSize,
    tab,
    beginCreateTime,
    endCreateTime,
    beginFinishTime,
    endFinishTime,
    beginMealTime,
    endMealTime,
    invoiceOpenStatus:
      Number(invoiceOpenStatus) === INVOICE_OPEN_STATUS.OFFLINE
        ? INVOICE_OPEN_STATUS.INVOICED
        : invoiceOpenStatus,
    ...rest,
  };
};

const getInitialParams = () => ({
  per_page: 20,
  cur_page: 1,
  companyPayStatus: -1,
  beginFinishTime: moment('00:00:00', 'HH:mm:ss').subtract(6, 'day').format('YYYY-MM-DD HH:mm:ss'),
  endFinishTime: moment('23:59:59', 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
});

const model = {
  state: {
    queryParams: getInitialParams(),
    invoiceManageParams: {
      cur_page: 1,
      per_page: 50,
    },
    tab: 0,
    orderList: [],
    orderListTotal: 0,
    companyTab: [],
    invoicingList: [],
    invoiceList: [],
    invoiceManageList: [], // 发票关联列表
    invoiceManageListTotal: 0,
    companyList: [],
    openToken: '',
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { bill }, getState }) => {
    const fetch = (url, options) => {
      const { union_shop_id } = getState().basic;
      return utilFetch(url, {
        ...options,
        params: {
          unionShopId: union_shop_id,
          ...(options && options.params),
        },
      });
    };

    return {
      async getOrderList(isExport = IS_EXPORT.NO) {
        const recordId = getUrlParam('recordId');
        const queryParams = formatQueryParams(getState().bill);
        const { page, pageSize } = queryParams;
        const data = await fetch('/saasmerchant/fsarea/invoice/orderlist', {
          params: recordId
            ? {
                page,
                pageSize,
                recordId,
              }
            : {
                ...queryParams,
                isExport,
              },
          type: 'GET',
        });
        if (data) {
          bill.setState({
            orderList: data.list || [],
            orderListTotal: data.total,
          });
        }
      },
      // 搜索
      onSearch(queryParams) {
        bill.setState({ queryParams });
        bill.getOrderList();
      },
      // 底部换页
      onNav(page) {
        const { queryParams } = getState().bill;
        bill.setState({ queryParams: { ...queryParams, cur_page: page } });
        bill.getOrderList();
      },
      // 重置筛选项
      onReset() {
        bill.setState({
          queryParams: getInitialParams(),
        });
      },
      setTab(tab) {
        const { queryParams } = getState().bill;
        bill.setState({ tab, queryParams: { ...queryParams, cur_page: 1 } });
        bill.getOrderList();
      },
      async getDepartmentList() {
        try {
          const _companyList = await fetch('/saasmerchant/fsarea/billorder/departmentList');
          const companyList = [{ companyId: '', companyName: '全部' }, ...(_companyList || [])];

          bill.setState({
            companyList,
          });
        } catch (error) {
          message.error('获取部门列表失败');
        }
      },
      setInvoiceSelected(companyId, invoiceId) {
        const { companyTab } = getState().bill;
        bill.setState({
          companyTab: companyTab.map((comp) =>
            comp.companyId === companyId
              ? {
                  ...comp,
                  invoiceList: comp.invoiceList.map((inv) => ({
                    ...inv,
                    selected: inv.invoiceId === invoiceId,
                  })),
                }
              : comp,
          ),
        });
      },
      async invoiceOpen({ companyInvoiceIds, email }, callback) {
        const { openToken } = getState().bill;
        const data = await fetch('/saasmerchant/web/company/invoice/open', {
          type: 'POST',
          useJson: true,
          params: {
            openToken,
            companyInvoiceIds,
            email,
          },
        });
        if (data) {
          callback();
        }
      },
      async getInvoiceList() {
        const { invoiceManageParams } = getState().bill;
        const { beginTime_endTime, cur_page, per_page, ...rest } = invoiceManageParams;
        const [beginApplicationTime, endApplicationTime] = (beginTime_endTime || []).map(format);
        const data = await fetch('/saasmerchant/fsarea/invoice/manage', {
          params: {
            ...rest,
            beginApplicationTime,
            endApplicationTime,
            page: cur_page,
            pageSize: per_page,
            invoiceId: getUrlParam('invoiceId'),
          },
        });
        if (data) {
          bill.setState({
            invoiceManageList: data.list,
            invoiceManageListTotal: data.total,
          });
        }
      },
      // 搜索
      onInvoiceSearch(invoiceManageParams) {
        bill.setState({ invoiceManageParams });
        bill.getInvoiceList();
      },
      // 底部换页
      onInvoiceNav(page) {
        const { invoiceManageParams } = getState().bill;
        bill.setState({ invoiceManageParams: { ...invoiceManageParams, cur_page: page } });
        bill.getInvoiceList();
      },
      // 重置筛选项
      onInvoiceReset() {
        bill.setState({
          invoiceManageParams: {
            per_page: 50,
            cur_page: 1,
          },
        });
      },
      async invoiceRetry(recordId, callback) {
        const data = await fetch('/saasmerchant/web/company/invoice/retry', {
          type: 'POST',
          useJson: true,
          params: {
            recordId,
          },
        });
        callback(data);
      },
    };
  },
};

export default model;
